<template>
  <div
    class="card h-full bg-surface shadow-xl relative"
    :class="{
      'rounded-3xl': !channelStore.isAsMonacoFanToken,
      'w-[312px] max-w-full min-h-[240px]': !variant || variant === 'regular',
      'w-full ': variant === 'responsive',
    }"
  >
    <!-- Thumbnail area -->
    <div class="relative">
      <figure
        :class="{ 'rounded-t-3xl': !channelStore.isAsMonacoFanToken }"
        class="aspect-[230_/_150] bg-fill-brand-hover"
      >
        <Skeleton width="312px" height="203px" border-radius="0" />
      </figure>

      <div class="absolute right-3.5 top-3.5">
        <Skeleton width="32px" height="32px" border-radius="50%" />
      </div>

      <!-- Status badge -->
      <div class="absolute top-4 left-4">
        <Skeleton
          :width="statusWidths[skeletonIndex % statusWidths.length]"
          height="28px"
          border-radius="8px"
        />
      </div>
    </div>

    <!-- Card body -->
    <div
      class="card-body p-4 gap-1 flex flex-col items-start justify-between shadow-3xl bg-surface"
      :class="{ 'rounded-b-3xl': !channelStore.isAsMonacoFanToken }"
    >
      <div class="w-full flex items-start justify-between">
        <div
          class="h-[68px] flex-col justify-start items-start gap-1 inline-flex"
        >
          <!-- Title -->
          <Skeleton
            :width="titleWidths[skeletonIndex % titleWidths.length]"
            height="20px"
            border-radius="4px"
          />
          <Skeleton
            :width="subtitleWidths[skeletonIndex % subtitleWidths.length]"
            height="16px"
            border-radius="4px"
          />
          <!-- Time -->
          <Skeleton
            :width="timeWidths[skeletonIndex % timeWidths.length]"
            height="14px"
            border-radius="4px"
          />
        </div>
      </div>

      <!-- Action area -->
      <div class="flex items-center justify-center gap-2 w-full">
        <div
          class="h-[89px] pt-1.5 pb-4 justify-center items-center gap-2 inline-flex w-full"
        >
          <Skeleton
            :width="actionWidths[skeletonIndex % actionWidths.length]"
            height="32px"
            border-radius="16px"
          />
        </div>
      </div>
    </div>

    <!-- User section -->
    <div
      class="h-16 p-4 justify-between items-center inline-flex w-full shadow-2xl"
      :class="{ 'rounded-b-3xl': !channelStore.isAsMonacoFanToken }"
    >
      <div
        class="w-full grow shrink basis-0 h-8 justify-between items-start flex"
      >
        <div class="flex-1 justify-start items-center gap-2 flex">
          <Skeleton width="32px" height="32px" border-radius="50%" />
          <Skeleton
            :width="usernameWidths[skeletonIndex % usernameWidths.length]"
            height="16px"
            border-radius="4px"
          />
        </div>

        <div class="flex flex-row gap-2 shrink-0">
          <Skeleton width="32px" height="32px" border-radius="50%" />
          <Skeleton width="32px" height="32px" border-radius="50%" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Skeleton from "@/components/ui/layout/skeleton.vue";
import { computed } from "vue";
import { useChannelStore } from "@/stores/channel.store";

const props = defineProps<{
  variant?: "responsive" | "regular";
  index?: number;
}>();

const channelStore = useChannelStore();

// Different widths for variety in skeleton appearance
const titleWidths = ["220px", "180px", "200px"];
const subtitleWidths = ["160px", "140px", "170px"];
const timeWidths = ["90px", "110px", "100px"];
const actionWidths = ["50%", "65%", "55%"];
const statusWidths = ["70px", "90px", "80px"];
const usernameWidths = ["80px", "100px", "90px"];

const skeletonIndex = computed(() => props.index ?? 0);
</script>
